import {
  DeleteGroupRegistrationMutation,
  GroupRegistrationQuery,
  GroupRegistrationsQuery,
  PendingGroupRegistrationsForUserQuery,
  UpdateGroupRegistrationMutation,
} from "src/api/GroupRegistration";
import { withApi, withApiMutation } from "src/stores/Api";
import { Level } from "types/code-generator";

export const UpdateGroupRegistration = withApiMutation(
  UpdateGroupRegistrationMutation,
  {
    name: "updateGroupRegistration",
  }
);

export const QueryGroupRegistrations = withApiMutation(
  GroupRegistrationsQuery,
  {
    name: "queryGroupRegistrations",
    options: ({ store }: any) => ({
      variables: {
        organizationId: store.organization.id,
      },
    }),
  }
);

export const QueryPendingGroupRegistrationsForUser = withApi(
  PendingGroupRegistrationsForUserQuery,
  {
    name: "queryPendingGroupRegistrationsForUser",
    options: ({ store, match, user }: any) => {
      let userId = match.params.id;

      if (user && user.level === Level.Student && user.accountOwner) {
        userId = user.accountOwner.id;
      }

      return {
        variables: {
          organizationId: store.organization.id,
          userId,
        },
      };
    },
  }
);

export const DeleteGroupRegistration = withApiMutation(
  DeleteGroupRegistrationMutation,
  {
    name: "deleteGroupRegistration",
  }
);

export const QueryGroupRegistration = withApi(GroupRegistrationQuery, {
  skip: ({ match }: any) => !match.params.id,
  options: ({ match }: any) => ({
    variables: { id: match.params.id },
  }),
  name: "queryGroupRegistration",
});
